import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import ReactDOM from "react-dom";

const LoadingManifestoDataView = ({
  EntityDetail,
  data,
  isVendor = false,
  isCustomer = false,
}) => {
  if (!data || !data.data || data.data.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "297mm",
          width: "210mm",
          bgcolor: "white",
          border: "2px solid #ef4444",
          borderRadius: 2,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          m: 0,
          p: 4,
        }}
      >
        <Typography
          variant="h6"
          color="error"
          align="center"
          sx={{
            bgcolor: "#fef2f2",
            p: 3,
            borderRadius: 1,
            border: "1px solid #ef4444",
            fontWeight: "bold",
          }}
        >
          No data available.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <div
        sx={{
          flex: 1,
          overflowY: "auto",
          p: 3,
          bgcolor: "#f9fafb",
          "@media print": { bgcolor: "white", p: 2 },
        }}
      >
        {/* ✅ Header with Logo and Title */}
        <div
          style={{
            padding: 8,
            borderBottom: "2px solid black",
            marginBottom: 16,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ flex: "0 0 auto", marginRight: "16px" }}>
            <img
              src={data?.logo?.url || "/logonew.png"}
              alt="Logo"
              style={{ height: "60px" }}
            />
          </div>
          <div>
            <div
              style={{
                fontSize: 22,
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Manifesto
            </div>
            <div
              style={{
                fontSize: 14,
                textAlign: "center",
                marginTop: 4,
              }}
            >
              {data?.entityName || "Entity Name"}
            </div>
          </div>
        </div>

        {/* 👇 Manifesto Table Content */}
        {data.data.map((loading, index) => (
          <div key={index}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                Loading ID: {loading.loadingId} (Total Weight:{" "}
                {loading.totalWeight} kg)
              </div>
              <div>
                Loading Time:{" "}
                {moment(loading.loadingTime).format("MM/DD/YYYY hh:mm A")}
              </div>
            </div>

            <div style={{ width: "100%", overflowX: "auto", marginTop: "8px" }}>
              <style>
                {`
                  table, th, td {
                    border: 1px solid black;
                    border-collapse: collapse;
                    margin-bottom: 20px;
                  }
                  th, td {
                    padding: 5px;
                  }
                `}
              </style>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th>Shipment ID</th>
                    <th>Sender</th>
                    <th>Receiver</th>
                    <th>Source Branch</th>
                    <th>Destination Branch</th>
                    <th>Weight (kg)</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading.shipmentId.map((shipment, idx) => (
                    <tr key={shipment._id}>
                      <td>{shipment.shipmentId || "N/A"}</td>
                      <td>
                        {!isVendor && !isCustomer
                          ? shipment?.customerId?.customerUser?.name
                            ? `CUS: ${shipment.customerId.customerUser.name}`
                            : shipment?.vendor?.ownerName
                            ? `VEN: ${shipment.vendor.ownerName}`
                            : "N/A"
                          : "N/A"}
                      </td>
                      <td>{shipment.receiver?.customerUser?.name || "N/A"}</td>
                      <td>{shipment.sourceBranch?.name || "N/A"}</td>
                      <td>{shipment.destinationBranch?.name || "N/A"}</td>
                      <td>{shipment.weight || 0}</td>
                      <td>{shipment.status || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
};

export const generateManifestoPrint = (
  data,
  { isVendor = false, isCustomer = false }
) => {
  const manifestoWindow = window.open("", "_blank");
  if (!manifestoWindow) {
    console.error("Failed to open new window for printing");
    return;
  }

  manifestoWindow.document.write(`
    <html>
    <head>
      <title>Shipment Manifesto</title>
      <script src="https://unpkg.com/react@18.2.0/umd/react.production.min.js"></script>
      <script src="https://unpkg.com/react-dom@18.2.0/umd/react-dom.production.min.js"></script>
      <script src="https://cdn.tailwindcss.com"></script>
      <style>
        @media print {
          body * { visibility: hidden; }
          #manifesto-content, #manifesto-content * { visibility: visible; }
          #manifesto-content { 
            position: absolute; 
            left: 0; 
            top: 0; 
            width: 210mm; 
            height: 297mm; 
            margin: 0; 
            padding: 16px; 
            box-shadow: none; 
            box-sizing: border-box;
          }
          .no-print { display: none; }
          @page { size: A4 portrait; margin: 0; }
        }
      </style>
    </head>
    <body>
      <div id="manifesto-content" style="display: flex; justify-content: center;"></div>
    </body>
    </html>
  `);
  manifestoWindow.document.close();

  setTimeout(() => {
    const contentRoot =
      manifestoWindow.document.getElementById("manifesto-content");
    if (contentRoot) {
      const manifestoElement = manifestoWindow.document.createElement("div");
      contentRoot.appendChild(manifestoElement);
      try {
        ReactDOM.render(
          <LoadingManifestoDataView
            data={data}
            isVendor={isVendor}
            isCustomer={isCustomer}
          />,
          manifestoElement
        );
      } catch (error) {
        console.error("ReactDOM.render error:", error);
      }
    } else {
      console.error("manifesto-content element not found");
    }
  }, 100);
};

export default LoadingManifestoDataView;
